// French for the ENGAGEMENTS zone: one card per engagement — position, gate tally, route grid.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Engagements': 'Mandats',
  '{n} active': '{n} actif(s)',
  'none active': 'aucun actif',
  '{n} archived': '{n} archivé(s)',
  'New engagement': 'Nouveau mandat',
  'No engagement on this client yet — so no phase, no gate, and nothing on this page claims one.': 'Aucun mandat chez ce client pour l’instant — donc aucune phase, aucun gate, et rien sur cette page n’en revendique un.',
  'archived {date}': 'archivé {date}',
  '{currency} estimate': 'Estimation {currency}',
  'kickoff': 'Kick-off',
  'phase': 'phase',
  'of': 'sur',
  'no gate': 'aucun gate',
  'Open {code}': 'Ouvrir {code}',
  'gate engine did not answer': 'le moteur de gate n’a pas répondu',
  'tally not evaluable': 'bilan non évaluable',
  'Lifecycle': 'Cycle de vie',
  'automatic': 'automatique',
  'manual': 'manuel',
  'No gate was evaluated for this engagement.': 'Aucun gate n’a été évalué pour ce mandat.',
  'gate not evaluable': 'gate non évaluable',
  // ROUTE_LABEL — the six cells of the route grid
  'Documents': 'Documents',
  'Register': 'Registre',
  'Agent': 'Agent',
  'Proposals': 'Propositions',
  'Contracting': 'Contrat',
  'Acceptance': 'Acceptation',
}, 'ClientEngagementCards');
